<div class="chart-container">
  <div class="question-barChart-tooltip" [ngStyle]="{left: tooltipX + 'px', top: tooltipY + 'px', display: tooltipVisible}">
    <div class="tooltip-heading">
      <div class="labelColorCode" [ngStyle]="{'background': tooltipColorBoxColorCode}"></div>
      <div class="labelName">{{ tooltipHeading }}</div>
    </div>
    <div class="tooltipData">
      <span>{{ tooltipLabelSynonyms }}</span>
      <span>{{ tooltipCount }}</span>
    </div>
  </div>
  <canvas #chartCanvas class="graph"></canvas>
</div>